import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DISCOUNT_CODE_AUTHORIZER_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { postDiscountCodeAuthorizerBatch } from '../../../../actions/sales/DiscountCodeAuthorizer';
import NewDiscountCodeAuthorizerForm from './NewDiscountCodeAuthorizerForm';

const NewDiscountCodeAuthorizer = ({
  breadcrumbs,
  dispatchPostDiscountCodeAuthorizerBatch,
}) => {
  const onSubmit = (formValues) => {
    const payload = formValues.customerId.map((item) => ({
      customerId: item.id,
      active: true,
    }));

    dispatchPostDiscountCodeAuthorizerBatch(payload);
  };

  const content = <NewDiscountCodeAuthorizerForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Autorizadores de Código de Descuento"
      subtitle="Crear autorizadores de código de descuento"
      content={content}
    />
  );
};

NewDiscountCodeAuthorizer.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostDiscountCodeAuthorizerBatch: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostDiscountCodeAuthorizerBatch: postDiscountCodeAuthorizerBatch,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Autorizadores de Códigos de Descuento',
      href: DISCOUNT_CODE_AUTHORIZER_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewDiscountCodeAuthorizer);
